/**
 * Adds Vivus svg tracing to the Wireframed Calls-to-Action paragraph type.
 * - Animate a svg with a parent containing the [data-svg-parent] tag.
 * - Mobile/Tablet: Animate when scrolled into view.
 * - Desktop: Animate on the link hover event.
 *
 * @author Brian McGill <github.com/bmcgill>
 */

import Vivus from 'vivus';

(function ($) {
  'use strict';

  Drupal.behaviors.initializeWireframedCTA = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  function initialize() {
    const $svgElements = $('div[data-svg-parent]');

    if (!$svgElements.length) return false;

    // Adjust start option depending on the device.
    let isMobile = window.matchMedia(
      'only screen and (max-width: 1023px)'
    ).matches;
    let $start = isMobile ? 'inViewport' : 'manual';

    $svgElements.each(function (index) {
      const el = this,
        $el = $(el),
        $svg = $el.find('svg'),
        viv = new Vivus($svg[0], {
          type: 'oneByOne',
          start: $start,
          reverseStack: true,
          animTimingFunction: Vivus.EASE_OUT,
          onReady: function () {
            // Initially hidden. Make visible before animating.
            $svg.css('visibility', 'visible');
          },
        });

      // If there are multiple embedded SVGs on a page their styles may conflict.
      // Class naming from Illustrator is generally .st0, .st1, etc.
      // Add a unique id to limit the scope.
      $svg.attr('id', 'wireframe' + index);
      let $styleItem = $svg.find('style');
      let $newText = $styleItem
        .html()
        .replace(/\.st/g, '#wireframe' + index + ' .st');
      $styleItem.html($newText);

      // Set SVG attributes so it will scale correctly.
      // Dimensions needs to be larger than the containing block, to ensure it can fill the block.
      let $bbox = $svg[0].getBBox(),
        $newHeight = 1000,
        $newWidth = 1000;
      if ($bbox.width < $newWidth || $bbox.height < $newHeight) {
        if ($bbox.width >= $bbox.height) {
          $newWidth = ($bbox.width * $newHeight) / $bbox.height;
        } else {
          $newHeight = ($bbox.height * $newWidth) / $bbox.width;
        }
      }

      $svg[0].setAttribute('width', $newWidth + 'px');
      $svg[0].setAttribute('height', $newHeight + 'px');

      // Set viewBox to remove whitespace around image
      $svg[0].setAttribute(
        'viewBox',
        $bbox.x.toFixed(2) +
          ' ' +
          $bbox.y.toFixed(2) +
          ' ' +
          $bbox.width.toFixed(2) +
          ' ' +
          $bbox.height.toFixed(2)
      );

      if (!isMobile) {
        // Play on hover.
        $el
          .parent()
          .find('a')
          .hover(
            function () {
              viv.reset().play();
            },
            function () {
              viv.stop().play(-2);
            }
          );
      }
    });
  }
})(jQuery);
